import SummaryTableComponent from "./SummaryTable.Component";

export default SummaryTableComponent;
